export default __webpack_public_path__ + "static/GT-America-Standard-Light-cea4ba4df35178a51726976fbcbcf71b.ttf";